<template>
  <a
    href="https://connect.vokalis.ai"
    target="_blank"
    title="Vokalis Connect - no-code database tool"
  >
    <img
      v-if="collapsed"
      src="@baserow/modules/core/static/img/favicon_48.png"
      alt="Vokalis Connect - no-code database tool"
      height="14"
    />
    <Logo
      v-else
      height="14"
      alt="Vokalis Connect - no-code database tool"
    />
  </a>
</template>

<script>
export default {
  name: 'ExternalLinkBaserowLogo',
  props: {
    collapsed: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
}
</script>
